import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from './LoginForm';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Contribute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (user) {
    return <Navigate to="/admin/requests" replace />;
  }

  return <LoginForm />;
}

